import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo, useState, useCallback } from 'react';
import { styled } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MuiPopper from '@mui/material/Popper';
import MuiBox from '@mui/material/Box';
import { PopupRoot, FilterIcon } from '../common/FilterPopover.js';
import '../common/InputField.js';
import DatePicker from '../../../../DatePicker/DatePicker.js';
import Dropdown from '../../../../Dropdown/Dropdown.js';
import '../../../../BaseDropdown/BaseDropdown.js';
import '../../../../BaseDropdown/types.js';
import '../../../../BaseDropdown/components/VirtualizedMenuList.js';
import '../../../../Dropdown/components/OptionItem.js';
import '../../../../Dropdown/components/Menu.js';
import 'tslib';
import '../../../../Dropdown/context/DropdownProvider.js';
import 'react-select';
import { dateFilters } from '../../../utils/filters/index.js';
import Button from '../../../../Button/Button.js';
import '../../../../Button/SplitButton.js';

const _DatePicker = styled(DatePicker) `
  width: 100%;
  margin: ${({ theme }) => theme.spacing(2.5, 0, 0)};
`;
const Popper = styled(MuiPopper) `
  z-index: 10;
`;
const ButtonContainer = styled(MuiBox) `
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4, 2.5, 2.5, 2.5)};
  display: flex;
  justify-content: space-between;
`;
const StyledPopupRoot = styled(PopupRoot) `
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const OPTIONS = [
    { label: 'Equals', value: 'exactDate' },
    { label: 'Greater Than', value: 'greaterThanDate' },
    { label: 'Less Than', value: 'lessThanDate' },
    { label: 'Not Equal', value: 'notEqualDate' },
    { label: 'In range', value: 'betweenDate' },
];
const _Dropdown = styled(Dropdown) `
  width: 100%;
  margin: ${({ theme }) => theme.spacing(1)};
`;
const DateFilter = ({ column, fromPlaceholder = 'Enter Date....', toPlaceholder = 'Enter Date....', clearLabel = 'Clear', applyLabel = 'Apply', datePickerLocale, optionLabels, }) => {
    const options = useMemo(() => {
        if (optionLabels) {
            return OPTIONS.map(option => (Object.assign(Object.assign({}, option), { label: optionLabels[option.value] })));
        }
        return OPTIONS;
    }, [optionLabels]);
    const [filterType, setFilterType] = useState(options[0]);
    const [fromDate, setFromValue] = useState(null);
    const [toValue, setToValue] = useState(null);
    const [anchorEl, setFilterAnchorEl] = useState();
    const isRangeFilter = useMemo(() => {
        return (filterType === null || filterType === void 0 ? void 0 : filterType.value) === 'betweenDate';
    }, [filterType]);
    const applyDisabled = useMemo(() => {
        return !fromDate || (isRangeFilter && !toValue);
    }, [isRangeFilter, toValue, fromDate]);
    const openFilter = useCallback((e) => {
        e.stopPropagation();
        setFilterAnchorEl(e.target);
    }, []);
    const closeFilter = useCallback((e) => {
        e.stopPropagation();
        setFilterAnchorEl(undefined);
    }, []);
    const onClick = useCallback(() => {
        var _a, _b;
        if (!(filterType === null || filterType === void 0 ? void 0 : filterType.value)) {
            return;
        }
        const filter = dateFilters[filterType.value];
        column.setFilter({
            filter,
            value: {
                filter,
                date: (_a = fromDate === null || fromDate === void 0 ? void 0 : fromDate.getTime) === null || _a === void 0 ? void 0 : _a.call(fromDate),
                secondaryDate: (_b = toValue === null || toValue === void 0 ? void 0 : toValue.getTime) === null || _b === void 0 ? void 0 : _b.call(toValue),
            },
        });
        setFilterAnchorEl(undefined);
    }, [column, filterType, fromDate, toValue]);
    const clearFilter = useCallback(() => {
        setFromValue(null);
        setToValue(null);
        column.setFilter(undefined);
    }, [column]);
    return (jsxs(Fragment, { children: [jsx(FilterIcon, { onClick: openFilter }), jsx(Popper, Object.assign({ open: !!anchorEl, anchorEl: anchorEl, onClick: e => e.stopPropagation() }, { children: jsx(ClickAwayListener, Object.assign({ onClickAway: closeFilter }, { children: jsxs(StyledPopupRoot, Object.assign({ elevation: 0, "data-testid": "datefilter" }, { children: [jsx(_Dropdown, { "data-testid": "filter-options", value: filterType, onChange: setFilterType, options: options }), jsx(_DatePicker, { "data-testid": "filter-input", placeholder: fromPlaceholder, headerLocale: datePickerLocale, onChange: setFromValue, value: fromDate }), isRangeFilter && (jsx(_DatePicker, { "data-testid": "filter-end-input", placeholder: toPlaceholder, headerLocale: datePickerLocale, onChange: setToValue, value: toValue })), jsxs(ButtonContainer, { children: [jsx(Button, Object.assign({ size: "small", variant: "ghost", onClick: clearFilter, disabled: !(fromDate || toValue) }, { children: clearLabel })), jsx(Button, Object.assign({ size: "small", variant: "ghost", onClick: onClick, disabled: applyDisabled }, { children: applyLabel }))] })] })) })) }))] }));
};

export { DateFilter, DateFilter as default };
//# sourceMappingURL=DateFilter.js.map
